import React from 'react';
import NextButton from './NextButton';

const ThirdClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Time to hit the road! Make sure you bundle up for the cold sweetie!
        Here's everything you'll need for your adventure
      </p>
      <img style={{ width: '100%' }} src='cold.jpg' />
      <p style={{ paddingTop: 16 }}>
        You deserve some more cute yoga gear to show off how fit you are 😍 Head
        to Lululemon (the one on Rush) to get your next clue.
      </p>
      <NextButton acceptedClues={[]} text="I'm here" />
    </div>
  );
};

export default ThirdClue;
